import Link from 'next/link'
import { VANISHING_INC_CUSTOMER_ID, BADGE_LABELS } from '@/communityQuestions'

export const Question = ({
  id,
  customerName,
  question,
  answers,
  productUrl,
}: QuestionProps) => {
  // Answers are already sorted by the backend: official responses first, then creators, then community
  const hasOfficialResponse = (answers || []).some(
    a => a.customerId === VANISHING_INC_CUSTOMER_ID
  )
  const communityBaseUrl = productUrl.replace(/\/+$/, '')
  const returnUrlParam = encodeURIComponent(communityBaseUrl)

  return (
    <li key={id} className="flex border p-2 mb-1" id={`question-${id}`}>
      <div className="w-full">
        <p className="mb-1 p-2 bg-[#f2f2f2]">
          <strong>{customerName} asks:</strong> {question}
        </p>
        {answers && answers.length > 0 && (
          <ul className="w-full py-2 px-3 border-t list-group list-group-flush">
            {answers.map((answer, index) => {
              const isOfficial = answer.customerId === VANISHING_INC_CUSTOMER_ID
              const isCreator = answer.isCreator && !isOfficial

              return (
                <li
                  key={answer.id}
                  id={`answer-${answer.id}`}
                  className="p-0 border-0 list-group-item"
                >
                  {isOfficial ? (
                    <span
                      className="inline-block px-2 py-1 text-xs font-semibold text-white rounded"
                      style={{ background: '#000' }}
                    >
                      {index + 1}. {BADGE_LABELS.OFFICIAL}
                    </span>
                  ) : isCreator ? (
                    <span className="inline-block px-2 py-1 text-xs font-semibold text-white bg-green-600 rounded">
                      {index + 1}. {answer.customerName} ({BADGE_LABELS.CREATOR}
                      ) responds:
                    </span>
                  ) : (
                    <span className="inline-block px-2 py-1 text-xs font-semibold text-white bg-gray-500 rounded">
                      {index + 1}. {answer.customerName} responds:
                    </span>
                  )}
                  <span className="ml-2">{answer.answer}</span>
                </li>
              )
            })}
          </ul>
        )}
        <div className="w-full">
          {!hasOfficialResponse && (
            <Link
              href={`${communityBaseUrl}/communityquestion/${id}?returnUrl=${returnUrlParam}`}
              className="float-end text-vi-red hover:underline"
              rel="nofollow"
            >
              Post an answer to this question
            </Link>
          )}
        </div>
      </div>
    </li>
  )
}

interface QuestionProps {
  productUrl: string
  id: string
  customerName: string
  question: string
  answers: {
    id: string
    customerId: number
    customerName: string
    answer: string
    isCreator: boolean
  }[]
}
